module.exports = __webpack_public_path__ + "static/media/VK.02f10d0c.png";